import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TokenService } from '../../../services/token.service';
import { Meta } from '@angular/platform-browser';
import { FormBuilder, Validators } from '@angular/forms';
import { ContactUsModel, FeedbackService } from '../../feedback/service';

export type ContactUsFields = 'FullName' | 'Email' | 'TopicId' | 'Message' | 'Company';

export interface Topic {
	Id: number,
	Name: string
};

@Component({
	selector: 'contact-us',
	templateUrl: 'contact-us.html',
	styleUrls: ['contact-us.scss']
})
export class ContactUsComponent implements OnInit {

	public topics: Topic[];
	public form: FormGroup;
	public isProcessing: boolean;

	public get f(): { [key in ContactUsFields ]: AbstractControl } {
		return this.form ? this.form.controls as { [key in ContactUsFields]: AbstractControl } : null;
	}

	constructor(
		private _fb: FormBuilder,
		private _navigationRouter: Router,
		private _service: FeedbackService,
		private _tokenService: TokenService,
		private _router: Router,
		private _meta: Meta
	) {
		this._meta.updateTag({ name: 'description',
			content: 'CropManage is a crop management web application developed ' +
			'by UCANR which help farmers manage irrigation and fertilization scheduling.'})

		this.topics = [
			{ Id: 1, Name: 'Account & Login Issues'},
			{ Id: 2, Name: 'General Questions'},
			{ Id: 3, Name: 'Get Notified about My Area'},
			{ Id: 4, Name: 'Request a Crop'},
			{ Id: 5, Name: 'Technical Support'},
			{ Id: 6, Name: 'User Feedback'},
		];

		this.isProcessing = false;
	}

	ngOnInit(): void {
		this._initializeForm();
	}

	private _initializeForm(): void {
		this.form = this._fb.group({
			FullName: [null, Validators.required],
			Email: [null, [Validators.required, Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
			Company: [''],
			TopicId: [null, Validators.required],
			Message: [null, Validators.required]
		});
	}

	public submit(): void {
		let data: ContactUsModel;
		let topic: Topic;

		if (!this.form.valid) {
			this.form.markAsDirty();
			return;
		}

		if (this.f.Company.value) {
			return;
		}

		this.isProcessing = true;

		topic = this.topics.find(x => x.Id === this.f.TopicId.value);

		data = {
			FullName: this.f.FullName.value,
			Email: this.f.Email.value,
			Topic: topic.Name,
			Message: this.f.Message.value
		}

		this._service.contactUs(data).then(() => {
			this._navigationRouter.navigate(['thank-you']);
		});
	}
}
